import { createPortal } from 'react-dom';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import {
	DeleteModalActions,
	DeleteModalBackdrop,
	DeleteModalCard,
	DeleteModalConfirm,
	DeleteModalConfirmSpinner,
	DeleteModalDismiss,
	DeleteModalText,
	DeleteModalTitle,
} from './DeleteConversationModal.styles';

const DeleteConversationModal = ({
	open,
	phase = 'confirm',
	onClose,
	onConfirm,
}) => {
	const t = useLanguageData('chat');

	if (!open) {
		return null;
	}

	const isDeleting = phase === 'deleting';
	const isDeleted = phase === 'deleted';
	const isBusy = isDeleting || isDeleted;

	const handleBackdropClick = () => {
		if (!isBusy) {
			onClose();
		}
	};

	const confirmLabel = (() => {
		if (isDeleted) {
			return t.deleteConversationDeleted;
		}

		if (isDeleting) {
			return t.deleteConversationDeleting;
		}

		return t.yes;
	})();

	return createPortal(
		<DeleteModalBackdrop onClick={handleBackdropClick}>
			<DeleteModalCard
				role="dialog"
				aria-modal="true"
				aria-labelledby="deleteConversationTitle"
				onClick={(event) => event.stopPropagation()}
			>
				<DeleteModalTitle id="deleteConversationTitle">
					{t.deleteConversationTitle}
				</DeleteModalTitle>
				<DeleteModalText>{t.deleteConversationWarning}</DeleteModalText>
				<DeleteModalActions>
					<DeleteModalDismiss type="button" onClick={onClose} disabled={isBusy}>
						{t.no}
					</DeleteModalDismiss>
					<DeleteModalConfirm
						type="button"
						onClick={onConfirm}
						disabled={isBusy}
						$success={isDeleted}
						aria-busy={isDeleting}
					>
						{isDeleting ? <DeleteModalConfirmSpinner aria-hidden="true" /> : null}
						{confirmLabel}
					</DeleteModalConfirm>
				</DeleteModalActions>
			</DeleteModalCard>
		</DeleteModalBackdrop>,
		document.body,
	);
};

export default DeleteConversationModal;
